import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_38_95_1M_15_19',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_38_95_1m_15_19_usd',
			ARS: 'simple_premium_1m_44900_1m_17900_ars',
			AUD: 'simple_premium_1m_59_99_1m_19_99_aud',
			BRL: 'simple_premium_1m_219_1m_85_99_brl',
			CAD: 'simple_premium_1m_49_99_1m_19_99_cad',
			CLP: 'simple_premium_1m_36900_1m_14900_clp',
			COP: 'simple_premium_1m_161900_1m_62900_cop',
			DKK: 'simple_premium_1m_259_1m_99_99_dkk',
			EUR: 'simple_premium_1m_38_95_1m_15_19_eur',
			GBP: 'simple_premium_1m_38_95_1m_15_19_gbp',
			MXN: 'simple_premium_1m_749_1m_289_mxn',
			NOK: 'simple_premium_1m_389_1m_149_nok',
			PLN: 'simple_premium_1m_139_99_1m_56_99_pln',
			SEK: 'simple_premium_1m_369_1m_139_99_sek',
			TRY: 'simple_premium_1m_1519_1m_589_try',
		},
		primer: 'prd_AhGB51SiAWw3',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 31,
		priceMap: {
			USD: 15.19,
			ARS: 17900,
			AUD: 19.99,
			BRL: 85.99,
			CAD: 19.99,
			CLP: 14900,
			COP: 62900,
			DKK: 99.99,
			EUR: 15.19,
			GBP: 15.19,
			MXN: 289,
			NOK: 149,
			PLN: 56.99,
			SEK: 139.99,
			TRY: 589,
		},
		originalPriceMap: {
			USD: 38.95,
			ARS: 44900,
			AUD: 59.99,
			BRL: 219,
			CAD: 49.99,
			CLP: 36900,
			COP: 161900,
			DKK: 259,
			EUR: 38.95,
			GBP: 38.95,
			MXN: 749,
			NOK: 389,
			PLN: 139.99,
			SEK: 369,
			TRY: 1519,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			ARS: 44900,
			AUD: 59.99,
			BRL: 219,
			CAD: 49.99,
			CLP: 36900,
			COP: 161900,
			DKK: 259,
			EUR: 38.95,
			GBP: 38.95,
			MXN: 749,
			NOK: 389,
			PLN: 139.99,
			SEK: 369,
			TRY: 1519,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('female_yoga.pages.paywall.plans.4_weeks.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('female_yoga.pages.paywall.plans.4_weeks.period_text'), // month
		billingSubtitlePeriodText: $t('female_yoga.pages.paywall.plans.4_weeks.billing_period_text'), // 4 weeks
		footerPeriodText: $t('female_yoga.pages.paywall.plans.4_weeks.footer_period_text'), // 4-week
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		updatedTermsPeriodText: $t('female_yoga.pages.paywall.plans.4_weeks.terms_period_text'), // 'first month'
	}),
}
